<template>
    <EChart
        card
        class="mt-3"
        :options="chartOptions"
        :header="$t('traffic')"
        :error="requestChart.getError()"
        :loading="requestChart.getLoading()"
        type="time"
    >
        <template #nav>
            <MultiselectAvailableCampaigns v-model="campaigns" :disabled="requestChart.getLoading()" @change="loadData()" />
        </template>
    </EChart>
</template>



<script>
    import { chartDataGroupBy, generateEChartData } from '@/utils/chart';
    import cloneDeep from 'lodash/cloneDeep';
    import EChart from '@/components/common/EChart.vue';
    import MultiselectAvailableCampaigns from '@/components/common/MultiselectAvailableCampaigns.vue';

    export default {
        name: 'TrafficChart',
        components: {
            EChart,
            MultiselectAvailableCampaigns,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                requestChart: this.parentComponent.requestTrafficChart,
                requestCampaigns: this.$req('buyboxes/AvailableCampaigns'),
                campaigns: [],
            };
        },
        computed: {
            item() {
                return this.parentComponent.item;
            },
            timeRange() {
                return this.parentComponent.timeRange;
            },
            apiParams() {
                return {
                    urlParams: {
                        id: this.item.id,
                    },
                    requestParams: {
                        startDate: this.timeRange?.startDate,
                        endDate: this.timeRange?.endDate,
                    },
                };
            },
            groupBy() {
                return chartDataGroupBy(this.timeRange);
            },
            chartData() {
                return this.requestChart.getData() || [];
            },
            chartOptions() {
                const chartData = this.chartData.reduce(
                    (acc, item) => {
                        acc.impressions.push([item.date, item.impressions]);
                        acc.clicks.push([item.date, item.clicks]);
                        return acc;
                    },
                    { impressions: [], clicks: [] }
                );
                return {
                    yAxis: [
                        {
                            type: 'value',
                            name: this.$t('clicks'),
                            position: 'right',
                        },
                        {
                            type: 'value',
                            name: this.$t('offersDisplay'),
                        },
                    ],
                    series: [
                        {
                            name: this.$t('clicks'),
                            type: 'line',
                            data: generateEChartData(this.timeRange, chartData.clicks),
                        },
                        {
                            name: this.$t('offersDisplay'),
                            type: 'bar',
                            yAxisIndex: 1,
                            data: generateEChartData(this.timeRange, chartData.impressions),
                        },
                    ],
                };
            },
        },
        watch: {
            item: {
                immediate: true,
                handler: 'loadData',
            },
            timeRange: {
                immediate: false,
                handler: 'loadData',
            },
        },
        methods: {
            loadData() {
                this.requestChart.reset();
                this.fetchChart();
            },
            fetchChart(params = { cache: false }) {
                const apiParams = cloneDeep(this.apiParams);
                if (this.campaigns?.length) apiParams.requestParams.campaigns = this.campaigns.map(item => item.id).join(',');
                this.requestChart.get({ ...apiParams, ...params });
            },
            fetchCampaigns() {
                const id = this.$store.getters['plugin/getProducerPlugin'].id;
                return this.requestCampaigns.get({ urlParams: { id } });
            },
        },
    };
</script>
